module.exports = __webpack_public_path__ + "static/media/icon-truck-delivery-completed.a37cfb61.png";